import http from "./httpService";

const apiEndpoint = process.env.REACT_APP_API_PROSPECTSALESTOOL_URL + "/Dashboards";

export async function GetDashboard() {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint)
}
export async function GetDashboardsByMarket(marketId,groupId) {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint +`/GetDashboardsByMarket?marketId=${marketId}&userGroupId=${groupId}`)
}

export async function GetDashboardDetails(data) {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint + "/" + data.market_id + "/" + data.dashboard + "/" + encodeURIComponent(data.region) + "/" + encodeURIComponent(data.postcode) + "/" + encodeURIComponent(data.industry) + "/" + encodeURIComponent(data.subIndustry));
}

export async function GetGenericDashboard(data) {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint + "/" + data.market_id + "/generic/" + data.dashboard_id + "/" + encodeURIComponent(data.region) + "/" + encodeURIComponent(data.postcode) + "/" + encodeURIComponent(data.industry) + "/" + encodeURIComponent(data.subIndustry));
}

export async function GetNoCMDemandDashboard(data) {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint + "/" + data.market_id + "/nocmdemand/" + data.dashboard_id + "/" + encodeURIComponent(data.region) + "/" + encodeURIComponent(data.postcode) + "/" + encodeURIComponent(data.industry) + "/" + encodeURIComponent(data.subIndustry));
}

export async function GetNonSMPDashboard(data) {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint + "/" + data.market_id + "/nonsmp/" + data.dashboard_id + "/" + encodeURIComponent(data.region) + "/" + encodeURIComponent(data.postcode) + "/" + encodeURIComponent(data.industry) + "/" + encodeURIComponent(data.subIndustry));
}

export async function GetSMPDashboard(data) {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint + "/" + data.market_id + "/smp/" + data.dashboard_id + "/" + encodeURIComponent(data.region) + "/" + encodeURIComponent(data.postcode) + "/" + encodeURIComponent(data.industry) + "/" + encodeURIComponent(data.subIndustry));
}

export async function GetLocalValueDashboard(data) {
  http.addBearerAuthorization();
  return await http.get(apiEndpoint + "/" + data.market_id + "/localvalue/" + data.dashboard_id + "/" + encodeURIComponent(data.region) + "/" + encodeURIComponent(data.postcode) + "/" + encodeURIComponent(data.industry) + "/" + encodeURIComponent(data.subIndustry));
}

export async function SaveUpdateDashboards(data) {
  console.log(data, "data")
  http.addBearerAuthorization();
  return await http.post(apiEndpoint + '/SaveUpdateDashboards', data)
}

export default {
  GetDashboard,
  GetDashboardsByMarket,
  GetDashboardDetails,
  GetGenericDashboard,
  GetNoCMDemandDashboard,
  GetNonSMPDashboard,
  GetSMPDashboard,
  GetLocalValueDashboard,
  SaveUpdateDashboards
}
